<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" :params="params" />
	<el-tree-select
		v-else
		v-model="value"
		:data="params"
		:disabled="disabled"
		clearable
		filterable
		default-first-option
		placeholder="请选择下拉数据"
		class="select"
	/>
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: string;
		params: { label: string; value: string; [key: string]: any }[];
		disabled?: boolean;
		showDisabledText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const attr = useAttrs();

	const value = computed({
		get() {
			if (attr.multiple) {
				return props.modelValue ? props.modelValue.split(',') : [];
			} else {
				return props.modelValue;
			}
		},
		set(val) {
			emit('update:modelValue', val ? val?.toString() : '');
		},
	});
</script>

<style scoped>
	.select {
		width: 100%;
	}

	.show-value {
		display: flex;
		gap: 3px;
		flex-wrap: wrap;
	}
</style>
